











import { Component, Vue } from 'vue-property-decorator';
import OtComingSoonPage from '@/components/global/ot-coming-soon.vue';

@Component({
  components: {
    OtComingSoonPage,
  },
})
export default class OtComingSoonPageWrapper extends Vue {
  // * PROPS

  // * REFS

  // * DATA
  private data: unknown;

  // * COMPUTED

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
}
